/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { useTranslation } from "react-i18next";
//Custom libraries
import { OrderItemTable } from "../../widgets/order-item-table";
import FormattedPriceDisplay from "../../widgets/formatted-price-display";
import CustomFormattedPriceDisplay from "components/widgets/formatted-price-display/custom-formatted-price-display";

//UI
import { Divider, styled } from "@mui/material";
import {
  StyledBox,
  StyledButton,
  StyledGrid,
  StyledTypography,
} from "@hcl-commerce-store-sdk/react-component";
import { StyledPaper } from "components/elements";
import CloseIcon from "@mui/icons-material/CloseOutlined";

interface MiniCartContentProps {
  title: string;
  orderType: string;
  orderItems: any[];
  subtotalLabel: string;
  subtotal: number | null;
  subtotalCurrency: string;
  emptyCartMsg: string;
  cartLinkLabel: string;
  checkoutLinkLabel: string;
  handleCartOnClick: (e?: any) => void;
  handleCheckoutOnClick: (e?: any) => void;
  handleClose: (e?: any) => void;
  isOrderOwner: boolean;
  isB2B: boolean;
}


export const StyledCartPopper = styled("div")`
${({ theme }) => `
    box-shadow: none !important;
    z-index: 20;

    .popper-mini-cart-button {
      color: white;
      width: 100%;
      background-color: #263645;
      border-color: #263645;
      font-weight: 500;
      font-family: Inter;
      border-radius: 0px !important;
    }

    .popper-mini-cart-button:hover{
      color: white;
      width: 100%;
      background-color: #314659;
      border-color: #314659;
      font-weight: 500;
      border-radius: 0px !important;
    }

  `}
`;

const StyledMiniCartContent = React.forwardRef<any, MiniCartContentProps>((props: any, ref: any) => {
  const {
    title,
    orderType,
    orderItems,
    subtotalLabel,
    subtotal,
    subtotalCurrency,
    emptyCartMsg,
    cartLinkLabel,
    checkoutLinkLabel,
    handleCartOnClick,
    handleCheckoutOnClick,
    handleClose,
    isOrderOwner,
    isB2B,
  } = props;

  const { t } = useTranslation();

  return (
    <StyledCartPopper>
      <StyledPaper ref={ref} className="mini-cart-container" data-testid="mini-cart-popper">
        <StyledGrid container direction="row" justifyContent="space-between">
          <StyledGrid item xs={10}>
            {!isB2B ? (
              <StyledTypography variant="h6" className="horizontal-padding-2 top-padding-2 bottom-padding-2">
                {t("MiniCart.TitleCart")}
              </StyledTypography>
            ) : (
              <>
                <StyledTypography variant="h6" className="horizontal-padding-2 top-padding-2 bottom-padding-2">
                  {t("MiniCart.TitleCart")}
                </StyledTypography>
              </>
            )}
          </StyledGrid>
{/*           <StyledGrid item container xs={2} justifyContent="center" alignItems="center">
            <CloseIcon/>
          </StyledGrid> */}
        </StyledGrid>
        <Divider />
        
        {orderItems.length > 0 ? (
          <>
            <StyledBox style={{boxShadow: "none"}}>
              <OrderItemTable data={orderItems} preShip={true} miniCartView={true} handleMiniCartClose={handleClose} />
            </StyledBox>
            <Divider />
            <StyledGrid container justifyContent="space-between" className="horizontal-padding-2 vertical-padding-2">
              <StyledGrid item>
                <StyledTypography variant="body1" style={{fontSize: "20px"}} >Total</StyledTypography>
              </StyledGrid>
              <StyledGrid item>
                <StyledTypography variant="body1" style={{fontWeight: "600", fontSize: "20px"}} align="right">
                  <CustomFormattedPriceDisplay min={`${subtotal}`} currency={subtotalCurrency} />
                </StyledTypography>
              </StyledGrid>
            </StyledGrid>
          </>
        ) : (
          <StyledTypography align="center" className="horizontal-padding-2 vertical-padding-10">
            {emptyCartMsg}
          </StyledTypography>
        )}
        <Divider />
        <StyledBox className="horizontal-padding-2 vertical-padding-1" textAlign="center">
          {isB2B && !isOrderOwner ? (
            <StyledButton testId="handle-cart-on-click" color="secondary" onClick={handleCartOnClick}>
              {cartLinkLabel}
            </StyledButton>
          ) : (
            <>
              <StyledButton
                testId="handle-cart-on-click"
                color="secondary"
                className="right-margin-1 popper-mini-cart-button"
                onClick={handleCartOnClick}>
                {cartLinkLabel}
              </StyledButton>
            </>
          )}
        </StyledBox>
      </StyledPaper>
    </StyledCartPopper>
  );
});

export default StyledMiniCartContent;
